<div class="row mt-4 me-5 rounded-3 border shadow-lg content-container">

    @for (category of faqDataForm.FAQ; track $index; let catIdx = $index) {
    <div class="col-12">
        @if (editingCategoryIndex() !== catIdx) {
        <div class="d-flex align-items-center gap-2 mb-2">
            <div class="category-reorder">
                <i class="bi" [class.bi-arrow-up]="catIdx !== 0" (click)="moveCategory(catIdx, catIdx - 1)"></i>
                <i class="bi" [class.bi-arrow-down]="catIdx !== (faqDataForm.FAQ.length - 1)" (click)="moveCategory(catIdx, catIdx + 1)"></i>
            </div>
            <h2 class="bold italic mb-0">{{ category.label().value() }}</h2>
            <i class="bi bi-pencil-fill edit-icon" (click)="startEditCategory(catIdx, category.label().value())"></i>
        </div>
        }

        @if (editingCategoryIndex() === catIdx) {
        <div class="d-flex align-items-center gap-2 mb-2">
            <input class="form-control fs-4 fw-bold fst-italic" [formField]="category.label"
                (keydown.enter)="exitAndValidateEditCategory()" (keydown.escape)="cancelEditCategory(catIdx)" />
            <i class="bi bi-check-lg edit-icon text-success" (click)="exitAndValidateEditCategory()"></i>
            <i class="bi bi-x-lg text-danger edit-icon" (click)="cancelEditCategory(catIdx)"></i>
        </div>
        }
        <div cdkDropList [cdkDropListData]="category.blocks().value()" class="drop-list"
            [id]="'cat' + catIdx.toString()" [cdkDropListConnectedTo]="dropListIds()"
            (cdkDropListDropped)="drop($event, catIdx)">
            @for (block of category.blocks; track $index; let blockIdx = $index) {
            <div class="faq-dragable-box row" cdkDrag>
                <h3 class="col-1">{{($index + 1) + "\u00a0:\u00a0"}}</h3>
                <div class="form-floating col-5">
                    <input class="form-control" [id]="'floatingTextarea1Cat'+catIdx+'block'+blockIdx"
                        [formField]="block.question" />
                    <label [for]="'floatingTextarea1Cat'+catIdx+'block'+blockIdx">Question</label>
                </div>
                <div class="form-floating col-5">
                    <input class="form-control" [id]="'floatingTextarea2Cat'+catIdx+'block'+blockIdx"
                        [formField]="block.answer" />
                    <label [for]="'floatingTextarea2Cat'+catIdx+'block'+blockIdx">Reponse</label>
                </div>
                <div class="col-1">
                    <i class="bi bi-trash3-fill delete-icon" (click)="removeBlock(blockIdx, catIdx)"></i>
                </div>

            </div>

            }
        </div>
        <div class="buttons-holder">
            <button type="button" class="btn btn-white mb-3" (click)="addBlock(catIdx)">
                Ajouter une question à la categorie &#x276E;&nbsp;{{category.label().value()}}&nbsp;&#x276F;
            </button>
        </div>
    </div>

    }
    <div class="buttons-holder">
        <button type="button" class="btn btn-black" (click)="addCategory()">
            Ajouter une categorie à la FAQ
        </button>
    </div>
    <div class="buttons-holder">
        <button type="button" class="btn btn-danger mt-2 mb-2" [disabled]="!isFormDirty()" (click)="reset()">
            Annuler les changements
        </button>
        <button type="button" class="btn btn-success mt-2 mb-2" [disabled]="!isFormDirty()" (click)="validate()">
            Confirmer la Mise à Jour
        </button>
    </div>

</div>